import styled from 'styled-components';

import { BREAKPOINTS } from '../../../../../app/appConstants';

import { ColStyled } from '../../../components/wrappers/styled/WrappersStyled';

export const FooterSectionDividerStyled = styled.div`
    height: 24px;
    background-color: var(--color-surface-secondary);
`;

export const FooterSectionDividerRedesignStyled = styled.div`
    height: 5px;
    background: linear-gradient(90deg, rgba(196, 198, 222, 0) 0%, #C4C6DE 51.39%, rgba(196, 198, 222, 0) 100%);
`;


export const ContentWrapperStyled = styled.div`
    max-width: 1360px;
    margin: 0 auto;
    display: flex;
    font-size: 14px;
    line-height: 21px;
    flex-wrap: wrap;
    @media (max-width: ${BREAKPOINTS.medium}px) {
        font-size: 12px;
        line-height: 18px;
    }
    @media (max-width: ${BREAKPOINTS.small}px) {
        font-size: 12px;
        line-height: 18px;
        flex-direction: column-reverse;
    }
`;

export const LeftContainerStyled = styled(ColStyled)`
    flex-basis: 69%;
    padding: 64px 16px 64px 48px;
    background-color: ${({backgroundColor}) => backgroundColor || 'var(--color-white)'};
    position: relative;

    &:after {
        background-color: ${({backgroundColor}) => backgroundColor || 'var(--color-white)'};
        content: '';
        height: 100%;
        width: 100vw;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: -1;
    }

    @media (max-width: ${BREAKPOINTS.extraLarge}px) {
        padding: 64px 8px 64px 40px;
    }
    @media (max-width: ${BREAKPOINTS.medium}px) {
        padding: 32px 8px 32px 40px;
    }
    @media (max-width: ${BREAKPOINTS.small}px) {
        padding: 40px 8px 40px 16px;
        flex-basis: 100%;
    }
`;

export const InformationContainerStyled = styled.div`
    width: 82%;
    margin: 0 auto;
    color: ${({color}) => color || 'var(--color-surface-secondary)'};
    @media (max-width: ${BREAKPOINTS.extraLarge}px) {
        width: 89%;
        margin: 0 auto 0 0;
    }
    @media (max-width: ${BREAKPOINTS.large}px) {
        width: unset;
        margin: 0 auto 0 0;
    }
`;

export const InformationFlexContainer = styled.div`
    display: flex;
    margin-top: 50px;
    flex-wrap: wrap;
`;

export const InformationLeftColumnStyled = styled.div`
    padding-right: 8px;
    flex: 0 0 66.67%;
    @media (max-width: ${BREAKPOINTS.large}px) {
        flex-basis: 100%;
    }
    &.full-width {
        flex-basis: 100%;
    }
`;

export const InformationRightColumnStyled = styled.div`
    padding-left: 8px;
    flex: 0 0 33.33%;
    @media (max-width: ${BREAKPOINTS.large}px) {
        flex-basis: 100%;
        padding-left: 0;
        margin-top: 16px;
    }
`;

export const RightContainerStyled = styled(ColStyled)`
    flex-basis: 31%;
    padding: 64px 48px 64px 8px;
    background-color: ${({backgroundColor}) => backgroundColor || 'var(--color-base)'};
    position: relative;
    @media (max-width: ${BREAKPOINTS.extraLarge}px) {
        padding: 64px 40px 64px 8px;
    }
    @media (max-width: ${BREAKPOINTS.medium}px) {
        padding: 32px 8px;
    }
    @media (max-width: ${BREAKPOINTS.small}px) {
        padding: 32px 16px;
        flex-basis: 100%;
    }
`;

export const FooterSectionHeaderStyled = styled.h3`
    font-size: 14px;
    line-height: 21px;
    letter-spacing: 4px;
    font-weight: 700;
    margin-bottom: 24px;
    @media (max-width: ${BREAKPOINTS.medium}px) {
        font-size: 12px;
        line-height: 18px;
    }
`;

export const FooterParagraphStyled = styled.div`
    font-weight: 400;
    ${({ black }) => black && 'color: var(--color-surface-secondary);'}
`;

export const FooterLinksStyled = styled.a`
    font-weight: 400;
    color: ${({color}) => color || 'var(--color-surface-secondary)'};
    cursor: pointer;
    text-decoration: none;

    :hover {
        color: ${({color}) => color || 'var(--color-base)'};
        text-decoration: underline;
    }
`;

export const MailLinkStyled = styled(FooterLinksStyled)`
    color: var(--color-white);

    :hover {
        color: var(--color-white);
        text-decoration: underline;
    }
`;

export const ContactsFlexContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-left: 20%;
    height: 100%;
    @media (max-width: ${BREAKPOINTS.extraLarge}px) {
        padding-left: 10%;
    }
    @media (max-width: ${BREAKPOINTS.large}px) {
        padding-left: 5%;
    }
    @media (max-width: ${BREAKPOINTS.small}px) {
        padding: 0;
    }
`;

export const ContactsContainerStyled = styled.div`
    width: 60%;
    @media (max-width: ${BREAKPOINTS.medium}px) {
        width: unset;
    }
    @media (max-width: ${BREAKPOINTS.small}px) {
        width: 40%;
    }
`;

export const YearContainerDesktopStyled = styled(FooterParagraphStyled)`
    @media (max-width: ${BREAKPOINTS.small}px) {
        display: none;
    }
`;

export const YearContainerMobileStyled = styled(FooterParagraphStyled)`
    display: none;
    margin-top: 48px;
    @media (max-width: ${BREAKPOINTS.small}px) {
        display: block;
    }
`;
